import FeedItemSearchContainer from './containers/FeedItemSearchContainer'

export default FeedItemSearchContainer
